import { Skeleton } from '@/components/ui/skeleton';

export default function NavigationBarSkeleton() {
  return (
    <div className="fixed z-50 bottom-0 shadow-xl shadow-black/50 w-full bg-hbackground border-t border-hsecondary-300 text-hsecondary-700 flex justify-around items-end py-2 px-4 md:hidden mt-1 pb-4">
      {/* Home item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-8 w-8 rounded-md !bg-primary-50/70" />
      </div>

      {/* Casino item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-8 w-8 rounded-md !bg-primary-50/70" />
      </div>

      {/* Deportes item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-8 w-8 rounded-md !bg-primary-50/70" />
      </div>

      {/* Discover item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-8 w-8 rounded-md !bg-primary-50/70" />
      </div>
    </div>
  )
}
